import { trackCdp, trackEvent, trackGA } from 'utilities/tracking';

window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.KitsIndex.init());

Sq.Shop.KitsIndex = {
  utils: Sq.Shop.Utils,
  pageId: '#kits-index-page',

  init() {
    if ($(this.pageId).length === 0) {
      return;
    }

    this.getHtml();
    this.bindEvents();
    this.onPageView();
  },

  getHtml() {
    this.$page = $(this.pageId);
  },

  bindEvents() {
    this.$page.on('click', `[${this.utils.PRODUCT_DATA_ATTR}]`, (e) =>
      this.onProductClick(e)
    );
  },

  onPageView() {
    // Track
    this.utils.trackProductList(this.$page, {
      listName: 'Kits',
      impression: true,
    });
  },

  onProductClick(e) {
    const product = this.utils.productData(e.currentTarget);
    product.list = 'Kits';

    trackGA('ec:addProduct', product);
    trackGA('ec:setAction', 'click', { list: 'Kits' });
    trackEvent({
      name: 'Product',
      value: 'Click',
      params: product,
    });
    trackCdp({
      name: 'Click Product',
      params: {
        feature: 'shop',
        sku: product.sku,
      },
    });
  },
};
